import { Component, OnInit, OnDestroy } from '@angular/core';
import { AvantoRestaurantsService } from 'src/app/services/avanto-restaurants.service';
import { Restaurant } from 'src/app/avantoeats-util/models/restaurant/Restaurant';
import { Subscription } from 'rxjs';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';

@Component({
  selector: 'app-restaurant-banner',
  templateUrl: './restaurant-banner.component.html',
  styleUrls: ['./restaurant-banner.component.scss']
})
export class RestaurantBannerComponent implements OnInit, OnDestroy  {

  private restaurantSubscription:Subscription = new Subscription();
  private restaurantAvailabilitySubscription:Subscription = new Subscription();
  private sessionObserver: Subscription = new Subscription();
  private sessionMenuObserver: Subscription = new Subscription();

  loadedRestaurant:Restaurant;

  availabilityMsgPickup:string;
  availabilityMsgDelivery:string;
  isDelivery:boolean;
  restaurantHasBeenLoaded:boolean;
  //This is a filter that we apply to the background image.
  //  'soft-lighy' = a dark overlay on top of it. Used so you can easily read the text on screen
  //  'multiply'   = a VERY dark overlay on top of it. Used when the restaurant is about to close/open or is already closed/open
  backgroundBlendMode:string;

  constructor(private restaurantsService:AvantoRestaurantsService, private avantoSession:AvantoSessionService) { }

  ngOnInit() {
    this.backgroundBlendMode = "soft-light"
    this.restaurantHasBeenLoaded = false;

    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      this.isDelivery = session.orderType == SessionObject.ORDER_TYPE_DELIVERY;
    });

    this.sessionMenuObserver = this.avantoSession.orderAddressChangedSubject.subscribe(newAddress=>{
      if(this.restaurantHasBeenLoaded){
      this.restaurantsService.refreshRestaurantAvailability([this.loadedRestaurant.generateRestaurantInfoObject()],newAddress.lat,newAddress.lng)
      }
    })

    this.restaurantSubscription = this.restaurantsService.subject_selectedRestaurant.subscribe(restaurant=>{
      this.loadedRestaurant = restaurant;
      this.restaurantHasBeenLoaded = true;
    });

    //Watches the restaurant availability message for changes
    this.restaurantAvailabilitySubscription = this.restaurantsService.subject_restaurantAvailability.subscribe(results=>{
      const availability = results.entries().next().value[1];
      this.availabilityMsgDelivery = availability.deliveryAvailability.message;
      this.availabilityMsgPickup = availability.pickupAvailability.message;
    })
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.restaurantSubscription.unsubscribe();
    this.restaurantAvailabilitySubscription.unsubscribe();
    this.sessionObserver.unsubscribe();
    this.sessionMenuObserver.unsubscribe();
  }
}
